import { useGetPushNotificationSetting, usePatchNotificationSetting } from 'all-in-one-shared-api';
import { Switch } from 'antd';
import { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { HomeContext } from 'contexts/home/context';
import { useKeycloakReady } from 'hooks';

const Wrapper = styled.div`
  padding: 12px 20px;
  display: flex;
  align-content: center;
  gap: 6px;
  background-color: #fff;
`;

const PushNotification = () => {
  const { t } = useTranslation();
  const { ready, token } = useKeycloakReady();

  const { mutate: mutateHome, state } = useContext(HomeContext);
  const { userAccess } = state;
  const allowDM = userAccess?.allowDM ?? false;

  const [isNotiOn, setIsNotiOn] = useState(false);

  const { shouldFetch, data, mutate, isValidating } = useGetPushNotificationSetting('getNotiSettings', token ?? '');

  useEffect(() => {
    shouldFetch(ready);
  }, [ready, shouldFetch]);

  const { shouldFetch: patchNotiShouldFetch } = usePatchNotificationSetting(
    { name: 'setNotiSettings', params: { isNotiOn, notificationClaimType: data?.notificationClaimType ?? false } },
    token ?? '',
    data?.notificationClaimType ?? false,
    isNotiOn,
    {
      onSuccess: () => {
        patchNotiShouldFetch(false);
        mutate();
        mutateHome?.();
      },
      onError: () => {
        patchNotiShouldFetch(false);
      },
    },
  );

  useEffect(() => {
    if (!data) return;
    setIsNotiOn(data?.notificationMarketingUpdate);
  }, [data, data?.notificationMarketingUpdate]);

  const handleOnSwitch = (value: boolean) => {
    setIsNotiOn(value);
    patchNotiShouldFetch(true);
  };

  return (
    <Wrapper>
      <Switch loading={isValidating} checked={isNotiOn} onChange={handleOnSwitch} disabled={!ready || !allowDM} />
      <div>{isNotiOn ? t('settings.switchLabelOn') : t('settings.switchLabelOff')}</div>
    </Wrapper>
  );
};

export default PushNotification;
